/**
 * Format a number as a currency string
 * @param value The number to format
 * @param currency The currency code (default: USD)
 * @returns Formatted currency string
 */
export const formatCurrency = (value: number | undefined, currency = 'USD'): string => {
  if (value === undefined) return '$0.00';
  
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(value);
};

/**
 * Format an invoice number for display.
 * @param invoice The invoice object containing the number
 * @returns A 6-digit invoice number as a string
 */
export const formatInvoiceNumber = (invoice: { id?: string; invoice_number?: number } | undefined): string => {
  if (!invoice) return 'N/A';
  if (invoice.invoice_number) {
    return invoice.invoice_number.toString().padStart(6, '0');
  }
  return 'N/A';
};

/**
 * Format a number as a percentage
 * @param value The number to format (e.g., 0.25 for 25%)
 * @param decimalPlaces Number of decimal places to include
 * @returns Formatted percentage string
 */
export const formatPercentage = (value: number, decimalPlaces = 0): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  }).format(value);
};

/**
 * Format a number with thousands separators
 * @param value The number to format
 * @param decimalPlaces Number of decimal places to include
 * @returns Formatted number string
 */
export const formatNumber = (value: number, decimalPlaces = 0): string => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  }).format(value);
};
